'use client';

import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';

import { checkContext } from '../context-utils';
import { ToolsType } from './tools-types';

export const IntialToolsState: ToolsType = {
  imageEditMode: false,
  imageOverlayEditMode: false,
  actions: {
    contentHandler: (_type, _onAdd) => {},
  },
  productType: undefined,
};

export const ToolsContext = createContext<[ToolsType, Dispatch<SetStateAction<ToolsType>>] | null>(null);

export const setToolsState = (v: [ToolsType, Dispatch<SetStateAction<ToolsType>>] | null) => {
  v = checkContext<ToolsType>(v);
  return v[1];
};

export type ProviderProps = {
  toolsContext: ToolsType;
  children: ReactNode;
};

const ToolsProvider: FC<ProviderProps> = ({ toolsContext, children }) => {
  const [appState, dispatch] = useState<ToolsType>(toolsContext);

  return <ToolsContext.Provider value={[appState, dispatch]}>{children}</ToolsContext.Provider>;
};

export default ToolsProvider;
